import React from "react";
import ReactDom from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { Provider } from "react-redux";

import AuthProvider from "common/components/custom/auth-provider";
import { injectStore } from "common/services/http-interceptor";
import configureStore from "./common/redux/core/store.config";
import { ENV_CONFIG } from "common/config/env.config";
import { AuthMode } from "common/enums";
// CSP nonce patch - MUST be imported first before any library that injects styles
import "common/utils/cspNonce";

import "common/config/i18n";
import App from "./App";

import "./index.scss";

const rootElement = document.getElementById("root") as Element;
const root = ReactDom.createRoot(rootElement);
const Router =
  ENV_CONFIG.AUTH_MODE === AuthMode.KEYCLOAK ? BrowserRouter : HashRouter;

const store = configureStore();
injectStore(store);

root.render(
  <Provider store={store}>
    <Router basename="/">
      <AuthProvider>
        <App />
      </AuthProvider>
    </Router>
  </Provider>
);
